import axios from 'axios'

const { REACT_APP_MICROSERVICES_DOMAIN, REACT_APP_SOMOS_ID_MS_API_CLIENT_ID } = process.env

const getMsApiToken = async () => {
  const authData = {
    idApplication: REACT_APP_SOMOS_ID_MS_API_CLIENT_ID,
  }
  const meetApiAuth = `${REACT_APP_MICROSERVICES_DOMAIN}/meet-api/auth`

  return axios.post(`${meetApiAuth}`, authData)
}

export { getMsApiToken }
